import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Link } from 'gatsby';
import Layout from '../../../components/layout';
import { dates } from '../../../components/dates';
import { LinkResolution } from '../../../components/resolution';
import { MinutesHeader, minutes_type, minutes_status } from '../../../components/minutes';
import { r as scrap_the_cap } from '../../resolutions/2020/scrap-the-cap-social-security-payroll-deductions';
import { r as r_90 } from '../../resolutions/2020/R-90';
import { r as wild_wallace_forest_reconveyance } from '../../resolutions/2020/wild-wallace-forest-reconveyance';
export const resolutions = [scrap_the_cap, r_90, wild_wallace_forest_reconveyance];
export const date = '2020-08-12T18:30-07:00';
export const remote = true;
export const status = minutes_status.approved;
export const type = minutes_type.general;
export const m = {
  date,
  remote,
  status,
  type
};
export const {
  prev_path
} = dates(date);
export const _frontmatter = {};
const layoutProps = {
  resolutions,
  date,
  m,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <Layout mdxType="Layout">
	<MinutesHeader m={m} mdxType="MinutesHeader" />
	<dl className="agenda">
		<dt>6:30</dt><dd>Sign In</dd>
		<dt>7:00</dt><dd>Call To Order</dd>
		<dt>7:01</dt><dd><Link to="/pledge-of-allegiance" className="link" mdxType="Link">Pledge of Allegiance</Link></dd>
		<dt>7:02</dt><dd>Land Acknowledgment</dd>
		<dt>7:03</dt><dd><Link to={prev_path} className="link" mdxType="Link">Approve of previous meeting's minutes</Link></dd>
		<dt>7:04</dt><dd>Moment of Silence for Racial Justice</dd>
		<dt>7:05</dt><dd>Remembering John Lewis with <a href="https://www.reelectjohnlovick.org/">Representative John Lovick</a></dd>
		<dt>7:15</dt><dd>Primary Election Recap with Chris Roberts</dd>
		<dt>7:30</dt><dd>Conversation: In Support of Referendum-90 (and in support of SB 5395)</dd>
		<dd>
			<a href="https://www.approve90wa.org/">Approve90WA.org | Safe and Healthy Youth</a>
			<br />
			Beware of the right wing's attempt to confuse you on this one!
			State Senate Bill 5395, now law, requires public school districts to teach age-appropriate, inclusive sexual health education to K-12 students and excuses students at their parent or guardian’s request. Opponents of the law submitted enough signatures to the Secretary of State’s office, qualifying the referendum for the November ballot to strip students of vital health information—the first statewide ballot measure on sex education in the country.
		</dd>
		<dt>7:45</dt><dd>Conversation on Voter Registration with Gary McCaig and others</dd>
		<dt>7:50</dt><dd>Conversation with Endorsed Candidates  </dd>
		<dt>8:00</dt><dd>PCO Update</dd>
		<dt>8:10</dt><dd><Link to="/resolutions" className="link" mdxType="Link">Resolutions</Link>
			<ul className="menu">
				{resolutions.map(r => <li><LinkResolution r={r} status={true} mdxType="LinkResolution" /></li>)}
			</ul>
		</dd>
		<dt>8:20</dt><dd>New Business</dd>
		<dt>8:25</dt><dd>Good of the Order</dd>
		<dt>8:30</dt><dd>Adjourn</dd>
	</dl>
      <p>“The hurt of one woman is the hurt of all women — the honor of one woman is the honor of all women. Show honor and esteem for all women! Consider and treat them with deference or courtesy.”
        <br /><em>First Nations saying</em>
      </p>
      <pre>
Zoom Access<br />
Meeting ID: 867 6530 1177<br />
Password: 857244<br />
        <a href="https://us02web.zoom.us/j/86765301177?pwd=ZnVDZ3k5Ky9LL2JpZEdheVlPaXhkZz09">https://us02web.zoom.us/j/86765301177?pwd=ZnVDZ3k5Ky9LL2JpZEdheVlPaXhkZz09</a><br />
Phone Dial-in by your location<br />
        <a href="tel:+1-253-215-8782">+1-253-215-8782 US (Tacoma)</a>
      </pre>
      <p><strong parentName="p">{`32nd Legislative District Meeting`}</strong></p>
      <p><strong parentName="p">{`Wednesday, August 12, 2020, 7:00 PM`}</strong></p>
      <p><strong parentName="p">{`Via Zoom & Call-in`}</strong></p>
      <p>{`32democrats.org • `}<a parentName="p" {...{
          "href": "mailto:chair@32democrats.org"
        }}>{`chair@32democrats.org`}</a></p>
      <p><strong parentName="p">{`6:30 PM Sign In`}</strong></p>
      <p><strong parentName="p">{`7:00 Call To Order by Alan Charnley, Chair`}</strong></p>
      <p><strong parentName="p">{`7:01 Pledge of Allegiance`}</strong></p>
      <p><strong parentName="p">{`7:02 Land Acknowledgment`}</strong></p>
      <p>{`We in the 32nd LD acknowledge that we live and work on the ancestral
lands of the Duwamish, Tulalip, and the Puyallup Tribes, and next to
their ancestral waters, the Salish Sea. We honor with gratitude this
land, water, and the Puyallup, Tulalip, and Duwamish Peoples.`}</p>
      <p><strong parentName="p">{`~`}{` Moment of Silence to recognize the departure of`}</strong></p>
      <p><strong parentName="p">{`our former PCO and E-Board Member, Jin-ah Kim `}{`~`}</strong></p>
      <p><strong parentName="p">{`7:03 Approval of
`}<a parentName="strong" {...{
            "href": "https://32democrats.org/download/2020-07-08/"
          }}>{`July 8, 2020`}</a>{` Minutes,
M/S/C, Approved`}</strong></p>
      <p><strong parentName="p">{`7:04 Approval of Agenda, M/S/C, Approved`}</strong></p>
      <p><strong parentName="p">{`7:05	Remembering John Lewis with the message below
from Representative John Lovick`}</strong></p>
      <p>{`• `}<span className="underline">{`Rep. Lovick:`}</span>{` Everything John Lewis did,
he did it to bring the community together. I met Congressman John Lewis
in his office in D.C. and I asked him, how was he able to stand so firm
in the face of so much hate? He answered, "I keep walking and you should
never be bitter and you should never be angry. Don't let anyone break
your spirit." He also said, "We need to be socially kind to each other.
And, if you see something that is not right, not fair, not just, you
have to speak up. You have a morale obligation to say something and to
do something." These are messages that I've been able to use for a
long-time. Meeting him that day meant so much for me in my life, and I
miss him very much. Thank very much for letting me share these memories.
Some of us go to Olympia, but you, here in the LD, do this great work
and are the foot soldiers of our democracy, helping us get elected, and
letting us know about issues that come up in your neighborhoods.`}</p>
      <p><strong parentName="p">{`7:20 Primary Election Recap with Chris Roberts, State Committee Representative`}</strong></p>
      <p><span className="underline">Chris Roberts:</span> There are some good
results, and there are some results we should be concerned about. The
voter turnout, over 53%, was the highest it's been in recent elections.
The other good result is that, at the top of our ticket, most of our
candidates have done pretty well.</p>
      <p>{`A down side is in Pierce County, where `}<strong parentName="p">{`Representative Kim Schrier`}</strong>{`
might have problems, as she received only 31% of the vote. She received
a total 43% when combined with King County but the Democratic vote in
the 8th Congressional District vote was under 50%.`}</p>
      <p><strong parentName="p">{`Governor Jay Inslee received`}</strong>{` over 50%. Candidate
`}<strong parentName="p">{`Lt. Governor, Denny Heck`}</strong>{` (32nd LD endorsed) is 8 to 10 points ahead of
`}<strong parentName="p">{`Marko  Lillas`}</strong>{`. `}<strong parentName="p">{`Heck`}</strong>{` is ahead in all counties except for King. In
the other races, all of our endorsed candidates at the top of the ticket
are doing well except for `}<strong parentName="p">{`Gael Tarleton`}</strong>{`. We need to do a lot of work
here.`}</p>
      <p>{`The other race that needs our attention is with `}<strong parentName="p">{`Superintendent of
Public Instruction,`}</strong>{` `}<strong parentName="p">{`Chris Reykdal`}</strong>{`, our endorsed candidate. He is
only getting about 40% of the vote. This is a non-partisan race so we
need to let people know that `}<strong parentName="p">{`Chris Reykdal`}</strong>{` is the Democrat we are
supporting in this race. We have a lot of work to do to make sure he is
re-elected.`}</p>
      <p>{`On the legislative side, in the `}<strong parentName="p">{`42nd LD`}</strong>{`, `}<strong parentName="p">{`Representative Shewmake`}</strong>{`
is under 50% in her race in Whatcom County. In the `}<strong parentName="p">{`10th LD`}</strong>{`,
`}<strong parentName="p">{`Representative Paul`}</strong>{` is under 50% in his race. And, candidate `}<strong parentName="p">{`Helen
Price Johnson,`}</strong>{` is behind the appointed senator, also in the `}<strong parentName="p">{`10th`}</strong>{`.`}</p>
      <p>{`In the `}<strong parentName="p">{`19th LD`}</strong>{`, `}<strong parentName="p">{`Senator Takko`}</strong>{`, I'm sorry to report, is ahead
with only 44% with the rest of the vote going to two Republicans. And,
also in the `}<strong parentName="p">{`19th`}</strong>{`, `}<strong parentName="p">{`Representative Blake, Pos. 2,`}</strong>{` is similarly
down against his challenger.`}</p>
      <p>{`The Northwest Progressive Institute said that many of the blue districts
did well but in districts that are red, the Republicans did even better.`}</p>
      <p>{`Closer to home in the `}<strong parentName="p">{`5th LD,`}</strong>{` candidate `}<strong parentName="p">{`Ingrid Anderson`}</strong>{`, a
nurse, is ahead of `}<strong parentName="p">{`State Senator Mark Mullet`}</strong>{`. This will probably be
the most expensive race in WA State history.`}</p>
      <p>{`In the `}<strong parentName="p">{`29th LD`}</strong>{`, `}<strong parentName="p">{`Representative Steve Kirby`}</strong>{`, who opposed same sex
marriage when it came up, is only about 100 votes ahead of his
Democratic challenger.`}</p>
      <p>{`In the `}<strong parentName="p">{`32nd LD`}</strong>{`, our endorsed candidate, `}<strong parentName="p">{`Shirley Sutton,`}</strong>{` made it
through to the general election. In Pos. 2, the non-partisan candidate,
will advance but our endorsed candidate, `}<strong parentName="p">{`Rep.`}</strong>{` `}<strong parentName="p">{`Lauren Davis,`}</strong>{` is
way ahead.`}</p>
      <p>{`Our job now is to make sure people vote for the right candidates on
November 3rd.`}</p>
      <p><strong parentName="p">{`7:35 APPROVE Referendum-90 with Matthew Grover, Planned Parenthood
Votes NW`}</strong></p>
      <p><span className="underline">Matthew Grover:</span> Our State Legislature
passed SB 5395 in the 2020 session, and it was signed into law by
Governor Inslee, March 2020. Opponents then gathered enough signatures
to refer it to the ballot this November 3rd. We are now working to
APPROVE R-90, which is comprehensive sex education.</p>
      <p>{`At its heart, this is about equity throughout our state's education
districts. Because there has been no state law requiring sex education
to be taught, even though many districts have been able to develop their
own curriculum, others have not. Approving R-90 would require all school
districts to teach age-appropriate, medically accurate, and inclusive
sexual health education. Importantly, all parents and guardians will
have the ability to opt their student out. Also, the exact curriculum is
not mandated by the state. There are only guidelines of subject areas,
therefore local control by individual school districts remain in place.
We hope the 32nd LD will support R-90 so that all students, in every zip
code, can receive the education they need and deserve.`}</p>
      <p><span className="underline">Q: I've been seeing a lot of Phyllis Schlafley
moral type attack ads about sex education. Could you let us know some of
the misinformation being used by opponents so we could counter
it?</span></p>
      <p>{`A: Opponents have been spreading a lot of misinformation about what
comprehensive sex health includes. Please check out our website,
Facebook, Twitter -- Approve90wa.org. We are educating people about what
this curriculum will do and the fact that the legislation includes
parental opt-outs and local control -- meaning parents will have the
opportunity to select a curriculum for their students and then be able
to work hand-in-hand with educators on developing it.`}</p>
      <p><span className="underline">Q: Are you going to give scientifically sound
information?</span></p>
      <p>{`A. Yes, definitely. Without comprehensive sex education being taught
within our public schools, students and young people are going to
sources online, word-of-mouth from friends, and other non-reputable
sources. A huge component is making sure it is medically and
scientifically accurate.`}</p>
      <p><span className="underline">Q: The criticism I hear the most is that you
are teaching 4th-graders sex positions?</span></p>
      <p>{`A: That is simply not true. Yes, it is one of the lies that opponents
of sex ed promote. The focus of the K-5th grade curriculum is on
creating a foundation of developing healthy relationships and then
waiting until middle school and high school to talk about the sexual
health component.`}</p>
      <p><span className="underline">Q: Many conversations focus on the K-3
curriculum, and say this is much to early for sex education?</span></p>
      <p>{`A: The K-3 curriculum focuses only on social emotional learning. We
talk about the characteristics of a friend and knowing, for example,
what is appropriate and inappropriate touching so that we can prevent
any form of abuse that any young person might experience. So again, the
K-5 curriculum is only about developing relationships and focusing on
body autonomy.`}</p>
      <p><strong parentName="p">{`7:45 Conversation on Voter Registration with Gary McCaig`}</strong></p>
      <p><span className="underline">Gary McCaig:</span> I'm focusing on voter
registration for this critical election, November 3rd, 2020. Voter
registration efforts have been seriously impeded by the pandemic. I
worked with Cindy Black at *Fix Democracy First* to develop a voter
registration poster with** QR codes which are squares that can be
accessed with a smart phone. It is in several languages to inform
English and non-English speakers, how to register to vote. I would like
the 32nd LD to approve printing 100 copies of the poster. It will
include the 32nd LD identification along with a union bug. The posters
I've placed in store windows, so far, have been highly effective in
registering voters.</p>
      <p><strong parentName="p">{`M/S/C, Approved`}</strong></p>
      <p>{`To obtain posters, contact: `}<a parentName="p" {...{
          "href": "mailto:gary.mccaig@32democrats.org"
        }}>{`gary.mccaig@32democrats.org`}</a></p>
      <p><strong parentName="p">{`League of Women Voters - Voter Registration Links`}</strong></p>
      <p><strong parentName="p">{`Help your neighbors and friends register to vote on-line. Forms are available at this website in 15 languages:`}</strong></p>
      <p><a parentName="p" {...{
          "href": "https://www.vote411.org/register"
        }}>{`https://www.vote411.org/register`}</a></p>
      <p><strong parentName="p">{`8:05 Conversations with Endorsed Candidates`}</strong></p>
      <p>{`• `}<a parentName="p" {...{
          "href": "https://www.voteshirleysutton.com/"
        }}>{`Shirley Sutton, State House of Representatives,
Pos. 1`}</a></p>
      <p>{`• `}<a parentName="p" {...{
          "href": "https://electlaurendavis.com/"
        }}>{`Lauren Davis, State House of Representatives,
Pos. 2`}</a></p>
      <p>{`• `}<a parentName="p" {...{
          "href": "https://www.reelectjudgedougnorth.com/"
        }}>{`Douglass North, King County Superior Court,
Pos. 30`}</a></p>
      <p><strong parentName="p">{`8:15 PCO COVID Update, Sally Soriano, for the 32nd PCO Coordinators Group`}</strong></p>
      <p>{`Sally Soriano: I'm reporting back on our August 4th PCO
phone-canvassing effort -- during COVID`}{`!`}{` Thanks to the many of you who
participated. Instead of our usual PCO lit drops at voter's doors, we
phoned voters. PCOs were each sent a list of about 90 "strong democrats"
or "likely democrats" and their phone numbers -- so the calls were all
friendly. We also sent addresses, a map, and a sample script. These
lists were compiled from the State Democrats' VoteBuilder database. The
downside of the lists, however, was that about 1/3 of the phone numbers
were not current. We advised PCOs about this potential. PCOs told voters
they could find our 32nd endorsed candidate list at our 32nd LD website
-- 32democrats.org. Overall, voters were generally appreciative of these
calls.`}</p>
      <p>{`One PCO recommended that, for the Nov. 3rd General Election, our 32LD
should supply each PCO with about 30 printed postcards with our endorsed
candidates. Then, when a wrong number is reached, the PCO could either
mail the postcard or drop it on the voter's porch. This approach would
ensure that all voters on the PCO's precinct list would be contacted.
The cost of 30 printed postcards and stamps would be about $20.`}</p>
      <p>{`Last Saturday (8/8), King County held their monthly PCO meeting,
chaired by Anne Udaloy. The 32nd was acknowledged for having highly
visible voter registration information on our website and for having
over 50% of our PCO positions filled. Two main topics were discussed:
First, several legislative districts have started using "text banking"
instead of "phone banking" to contact voters. They've found it to be
highly successful and will teach all the LDs how to "text bank". Second,
we discussed automating the PCO sign-up process given complexities in
the current system. Several LD representatives cautioned that this
automated system must be based in the LDs. This way, the PCO applicant
can be vetted and there can be a discussion about all of the volunteer
possibilities in the LD, in addition to PCO duties.`}</p>
      <p><strong parentName="p">{`8:25	PCO Appointment - Chris Roberts, SHL-32-0001`}</strong></p>
      <p><span className="underline">Chris Roberts:</span> I recently moved and I
look forward to continuing to be a very active PCO.</p>
      <p><strong parentName="p">{`M/S/C - Approved`}</strong></p>
      <p><strong parentName="p">{`8:30 Resolutions`}</strong></p>
      <p>{`• `}<a parentName="p" {...{
          "href": "https://32democrats.org/download/resolution-in-support-of-referendum-90/"
        }}>{`In Support of Referendum-90 (SB 5395)`}</a></p>
      <p><span className="underline">Carol McMahon:</span> We've had a presentation
tonight on APPROVE R-90, so I'll just go through some of the text of the
resolution:</p>
      <p>{`• Whereas, a strong majority of Washingtonians support requiring schools
to offer scientifically based, medically accurate, age-appropriate,
comprehensive sex education (86% support, 70% “strongly support,”
according to Planned Parenthood Votes Northwest); and`}</p>
      <p>{`• Whereas, SB 5395 would require school districts to adopt or develop,
consistent with state standards, comprehensive age-appropriate sexual
health education, as defined, for all students, and excuse students if
their parents request;`}</p>
      <p>{`• Therefore, be it resolved that the 32nd Legislative District
Democratic Organization urges all voters to vote “Approve” on Referendum
90 (SB 5395) in the November 2020 election.`}</p>
      <p><strong parentName="p">{`M/S/C - Approved`}</strong></p>
      <p>{`• `}<a parentName="p" {...{
          "href": "https://32democrats.org/download/scrap-the-cap-social-security-payroll-deductions/"
        }}>{`"Scrap the Cap" on Social Security Payroll Deductions`}</a></p>
      <p><span className="underline">Trudy Bialic:</span> The Social Security
payroll deduction issue was the biggest on my mind when I was elected
32nd LD Senior Advocate. Trump and the Republicans are announced that
they will defund Social Security if he is re-elected. This resolution
would not only stop their action but it would secure Social Security
passed the 2035 date when the surplus runs out. Congress has made
adjustments to the Social Security Act in the past. The Act started in
1935. In 1983, amendments were made: cutting the Cost of Living increase
out and Social Security was made a taxable income. So they have actually
cut it by 13% already, for people born after 1960. But now, Social
Security is being threatened with absolute defunding. This resolution
would eliminate the cap on payroll deductions, so millionaires and
billionaires will pay the same tax rate as lower and middle-income
families making below $137,000 a year. This current system is arbitrary,
it is unfair, and it needs to be fixed. Removing the cap would improve
benefits for current retirees and would strengthen benefits for future
generations, especially for millennials, who do not have pension plans.
This is an essential support and security system for millennials.</p>
      <p><span className="underline">Dean Fournier:</span> Having the cap is the
antithesis of a graduated income tax. We all pay a flat rate up to
$137,000. Trudy put this into the resolution. Scrapping the cap is a
leveler and it is important.</p>
      <p><strong parentName="p">{`M/S/C - Approved`}</strong></p>
      <p><a parentName="p" {...{
          "href": "https://32democrats.org/download/wild-wallace-forest-reconveyance/"
        }}>{`• Wild Wallace Forest Reconveyance`}</a></p>
      <p><span className="underline">Mary Rollins, 38th LD</span>: Off of Route 2,
near Index, Gold Bar and Sultan, there's state land and there is federal
land, and in between you have 5,300 acres, called the Wild Wallace.
Right now it is being logged by the Department of Natural Resources. We
are asking that Wild Wallace be returned to Snohomish County as a park.
They are logging right now within 500 feet of Wallace Falls. We want to
preserve what's left: <a href="https://www.wta.org/go-hiking/hikes/wallace-falls">https://www.wta.org/go-hiking/hikes/wallace-falls</a></p>
      <p>{`We've talked with three members of the Snohomish County Council and we
are talking to the Tribes. We have the support of the Snohomish County
Democrats, and the 38th LD and the 1st LD. Residents want a place to
hike, not a place to have to look at clear-cutting. We've temporarily
named it "Wild Wallace County Park".`}</p>
      <p><strong parentName="p">{`M/S/C - Approved`}</strong></p>
      <p><strong parentName="p">{`8:55 New Business`}</strong></p>
      <p>{`-none`}</p>
      <p><strong parentName="p">{`9:00 Good of the Order`}</strong></p>
      <p><span className="underline">Carin Chase</span>: I'm coming to you as a
32nd LD State Committee person and as National Delegate to the DNC. The
Convention is coming up next week, it is all virtual, and there are many
programs. I'll be sending the schedules to our 32nd LD Facebook page.
We've been able to meet with Black Lives Matter and we were able to make
sure that the National Platform includes a ban on chokeholds. Also,
there is wording on an infrastructure bank and language on Native
American boarding schools which is now included in the national
platform. This is all important work done by our WA State National
Delegation.</p>
      <p><span className="underline">Gray Petersen</span>: Today is the third
anniversary of the passing of a martyr, named Heather Heyer. She was the
sole person killed during the car attack in Charlottesville by a
neo-Nazi. There's a movie called "Hate in Charlottesville". Her last
post on Facebook was "if you're not angry, you're not paying attention."
We're doing our best to keep her in our thoughts given what is happening
with white supremacy violence in his country.</p>
      <p><span className="underline">Gray Petersen:</span> There is going to be a demonstration on Saturday for Black Lives Matter -- see the Facebook: <a href="https://www.facebook.com/BlackLivesMatterShoreline/">https://www.facebook.com/BlackLivesMatterShoreline/</a></p>
      <p><strong parentName="p">{`9:05 Adjourn`}</strong></p>
      <p><strong parentName="p">{`Next Meeting, Wednesday, September 9th`}</strong>{` (2nd Wednesday of the month)`}</p>
      <p><strong parentName="p">{`Respectfully submitted,`}</strong></p>
      <p><strong parentName="p"><em parentName="strong">{`Sally Soriano,`}</em>{` 32nd LD Secretary`}</strong></p>
      <p><a parentName="p" {...{
          "href": "mailto:sally.soriano@32democrats.org"
        }}>{`sally.soriano@32democrats.org`}</a></p>
    </Layout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      